import { render, staticRenderFns } from "./BackProductSort.vue?vue&type=template&id=6b025511&scoped=true"
import script from "./BackProductSort.vue?vue&type=script&lang=js"
export * from "./BackProductSort.vue?vue&type=script&lang=js"
import style0 from "./BackProductSort.vue?vue&type=style&index=0&id=6b025511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b025511",
  null
  
)

export default component.exports